import React, { useState } from "react";
import { InputField1 } from "../InputField1/InputField1";
import { SimpleSelect1 } from "../SimpleSelect/SimpleSelect1";
import Typography from "../Typography/Typography";
import { SetPersonTargetStyle } from "./SetPersonTargetStyle";
import { useGetCompanyUsers } from "../../hooks/useCrm";
import Button from "../Button/Button";
import { useParams } from "react-router-dom";
import { useSingleTarget } from "../../hooks/useManagement";
import { MiladiToShamsi } from "../../utils/Miladi_To_Shamsi";
import { separate } from "../../utils/separate";
import Loading from "../Loadings/LoadingTable";
import { FaEdit, FaTrash } from "react-icons/fa";
import { IoMdAdd } from "react-icons/io";
import { Spinner } from "reactstrap";
import TargetCard from "../TargetCard/TargetCard";
import { Tabs, Tab } from "react-bootstrap";
import { DeleteTargetModal } from "../Dialog/DeleteTargetModal";
import { EditTargetModal } from "../Dialog/EditTargetModal";
import { AddTargetUserModal } from "../Dialog/AddTargetUserModal";
import TargetUserTable from "../TargetUserTable/TargetUserTable";
const SetPersonTarget = () => {
  const [show, setShow] = useState({
    edit: false,
    delete: false,
    addUser: false,
  });
  const [targetId, setTargetId] = useState();
  const [targetObj, setTragetObj] = useState();

  const { id } = useParams();
  const { data: singleTarget, isLoading: targetLoading } = useSingleTarget({
    sale_target_id: id,
  });
  let userTargets = 0;

  for (let i = 0; i < singleTarget?.data?.usersSaleTarget.length; i++) {
    userTargets += singleTarget?.data?.usersSaleTarget[i].AmountUserSaleTarget;
  }

  const target = singleTarget?.data?.sale_target;
  const remainingTarget = target?.AmountSaleTarget - userTargets;

  if (targetLoading) {
    return <Loading />;
  }
  return (
    <SetPersonTargetStyle>
      <div className="row">
        <div className="col-12 d-flex justify-content-between mb-2">
          <Typography className="d-flex align-items-center">
            اطلاعات تارگت
          </Typography>
          <div className="d-flex">
            <Button
              className="m-0 mx-1"
              bgColor="#009ef7"
              onclick={() => {
                setTragetObj(target);
                setShow({ ...show, edit: true });
              }}
            >
              <FaEdit color="#fff" />
            </Button>
            <Button
              className="m-0 mx-1"
              bgColor="#f1416c"
              onclick={() => {
                setShow({ ...show, delete: true });
                setTargetId(target?.IdSaleTarget);
              }}
            >
              <FaTrash color="#fff" />
            </Button>

            {remainingTarget !== "0" ? (
              <Button
                className="m-0 mx-1"
                bgColor="#50cd89"
                onclick={() => {
                  setShow({ ...show, addUser: true });
                  setTargetId(target?.IdSaleTarget);
                }}
              >
                <IoMdAdd color="#fff" />
              </Button>
            ) : null}
          </div>
        </div>
        <div className="col-lg-3 col-md-6 col-12">
          <TargetCard
            bgColor="#009ef7"
            title={`بازه زمانی`}
            value={`${MiladiToShamsi(target?.FromDate)} تا ${MiladiToShamsi(
              target?.ToDate
            )}`}
          />
        </div>
        <div className="col-lg-3 col-md-6 col-12">
          <TargetCard
            bgColor="#f1416c"
            title="مبلغ تارگت کل"
            value={separate(target?.AmountSaleTarget) + " تومان"}
          />
        </div>
        <div className="col-lg-3 col-md-6 col-12">
          <TargetCard
            bgColor="#50cd89"
            title="باقیمانده از تارگت کل"
            value={separate(target?.AmountSaleTarget - userTargets)}
          />
        </div>
        <div className="col-lg-3 col-md-6 col-12">
          <TargetCard
            bgColor="#009ef7"
            title="مبلغ فروخته شده"
            value={separate(target?.all_sell) + " تومان"}
          />
        </div>
        <div className="col-lg-3 col-md-6 col-12">
          <TargetCard
            bgColor="#f1416c"
            title="باقیمانده از فروش"
            value={
              separate(target?.AmountSaleTarget - target?.all_sell) + " تومان"
            }
          />
        </div>
        <div className="col-lg-3 col-md-6 col-12">
          <TargetCard
            bgColor="#50cd89"
            title="تاریخ ایجاد تارگت"
            value={MiladiToShamsi(target?.created_at)}
          />
        </div>
        <div className="col-lg-3 col-md-6 col-12">
          <TargetCard
            bgColor="#009ef7"
            title="تعداد اعضای تارگت"
            value={singleTarget?.data?.usersSaleTarget.length}
          />
        </div>
        {target.user_updated && (
          <div className="col-lg-3 col-md-6 col-12">
            <TargetCard
              bgColor="#f1416c"
              title="به‌‌روز رسانی شده توسط"
              value={
                (target.user_updated?.FirstName
                  ? target.user_updated?.FirstName
                  : "") +
                " " +
                (target.user_updated?.LastName
                  ? target.user_updated?.LastName
                  : "")
              }
            />
          </div>
        )}
      </div>
      <TargetUserTable />
      <DeleteTargetModal
        show={show.delete}
        handleClose={() => setShow({ ...show, delete: false })}
        targetId={targetId}
      />
      <EditTargetModal
        show={show.edit}
        handleClose={() => setShow({ ...show, edit: false })}
        target={targetObj}
      />
      <AddTargetUserModal
        show={show.addUser}
        handleClose={() => setShow({ ...show, addUser: false })}
        targetId={targetId}
      />
    </SetPersonTargetStyle>
  );
};

export default SetPersonTarget;
